<template>
  <main>
    <div class="container">
      <div class="page_content" v-html="htmlContent" />
    </div>
  </main>
</template>

<script setup lang="ts">
import type { IAboutPage } from '@/types';

const { findOne } = useStrapi();
const response = await findOne<IAboutPage>('page-about', {
  populate: 'deep',
});

const data = response.data as unknown as IAboutPage;

useHead(usePageSeoMeta(data));

const htmlContent = data.content;
</script>
